import { ShiftSelectMouseOver, ShiftSelectorDetector } from './Helpers';
import { ShiftKeyChangeType, ShiftKeyMouseOverType } from '../Types/SharedFunctions/SharedFunctionTypes';

const ShiftKeyChange = (props: ShiftKeyChangeType) => {
	const shiftKeyActive = ShiftSelectorDetector(props.event, props.gridViewRef);

	props.shiftKeyChangeCallback(shiftKeyActive);
	props.disableFolderSelectionCallback(shiftKeyActive);

	if (props.event.shiftKey) {
		document.dispatchEvent(new Event('pointerover'));
	}
};

const ShiftKeyMouseOver = (props: ShiftKeyMouseOverType) => {
	if (!props.mouseDownRef.current && props.selectedItemsRef.current.length > 0 && props.shiftKeyDownRef.current) {
		ShiftSelectMouseOver(props.event, props.selectedItemsRef, props.gridViewRef, props.lastMousePosRef);
	} else {
		document.querySelectorAll('.item-shift-active').forEach((item) => item.classList.remove('item-shift-active'));
	}
};

export { ShiftKeyChange, ShiftKeyMouseOver };
